import * as actions from './actions';


export default (state = {}, action) => {
  switch (action.type) {
    case actions.INIT.END:
      return {
        ...action.selectedTemplate,
      };
    case actions.SET_NAME:
      return {
        ...state,
        value: {
          ...state.value,
          name: action.name,
        },
      };
    case actions.SET_ORDER:
      return {
        ...state,
        value: {
          ...state.value,
          order: action.order,
        },
      };
    case actions.SET_APPLICABLE:
      return {
        ...state,
        value: {
          ...state.value,
          projectItemTypeConfigId: action.projectItemTypeConfigId,
        }
      };
    case actions.SET_REMOVED:
      return {
        ...state,
        value: {
          ...state.value,
          isRemoved: action.value,
        },
      };
    case actions.INVALIDATE_CHANGES:
      return {
        ...state,
        changes: action.changes,
      };
    case actions.RESET_CHANGES.END:
      return {
        ...state,
        changes: 0,
        value: action.value,
      };
    case actions.CHECK_VALIDATION.END:
      return {
        ...state,
        errors: action.errors
      };
    case actions.REMOVE_ITEM:
      if (state.value.templateItems.length > 1) {
        return {
          ...state,
          value: {
            ...state.value,
            templateItems: state.value.templateItems.filter(item => item !== action.item)
          }
        };
      }
      return state;
    case actions.ADD_ITEM.END:
      return {
        ...state,
        value: {
          ...state.value,
          templateItems: [
            ...state.value.templateItems,
            {
              projectItemTypeConfigId: action.subItemOptions.length === 1 ? action.subItemOptions[0].id : null,
              itemTitle: `Prefix ${state.value.templateItems.length + 1}: [Parent Title] Suffix`,
              assignToId: 0,
              categoryId: 0
            }
          ]
        }
      };
    case actions.SET_ITEM_VALUE:
      return {
        ...state,
        value: {
          ...state.value,
          templateItems: state.value.templateItems.map(item => item === action.item ? {
            ...action.item,
            [action.attribute]: action.value
          } : item)
        }
      };
    case actions.EMPTY:
      return {};
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ../redux/store/configuration/project/editor/template/currentTemplate/reducer.js